import interceptor from "../common/interceptor";
import axios from "axios";
import { APIPaths } from "../common/constants";

export const GetShipments = (token, params) => {
  const queryString = new URLSearchParams(params).toString();
  const baseUrl = APIPaths.shipments;
  let url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
  //let url = `${APIPaths.shipments}?${params}`
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Error fetching shipments:", error?.response);
        reject(error?.response);
      });
  });
};
export const GetShipmentsViewers = (token, shipmentId) => {
  const url = `${APIPaths.shipment_viewer}${shipmentId}`;

  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Error fetching shipments:", error?.response);
        reject(error?.response);
      });
  });
};

export const GetShipmentsByFilter = (token, params, queryData = {}) => {
  const queryString = new URLSearchParams(queryData).toString();
  let url = `${APIPaths.shipments}?${
    queryString !== "" ? queryString + "&" : ""
  }${params}`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetSingleShipment = (token, id, isHome = false) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet(
        "Get",
        APIPaths.shipments + id + `/?home=${isHome}`,
        token,
        null
      )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetSingleShipmentPublically = (data, id) => {
  let url = `${APIPaths.shipments + id}/?token=${data}`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosWithoutHaeders("Get", url, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const GetShipmentSummary = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", APIPaths.shipments + "summary/", token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//Call For Add new Shipment [by Nisha]

export const CreateNewShipment = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.addNewShipment, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const UpdateShipment = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.addNewShipment, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//Call For Add new Shipment [by Nisha]

export const GetShipmentByID = (token, id) => {
  const url = `${APIPaths.addNewShipment}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//Add comments for chain of custody
export const ChainOfCustodyComments = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.custody_comments, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const ResolveAlertComments = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.resloved_alert_comment, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//Share shipment
export const ShareShipmentApi = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.share_shipment, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Error while sharing shipment:", error?.response);
        reject(error?.response);
      });
  });
};

//get share external link
export const CheckPasswordAgaintUUID = (uuid) => {
  const url = `${APIPaths.share_shipment}${uuid}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosWithoutHaeders("Get", url, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Error while sharing shipment:", error?.response);
        reject(error?.response);
      });
  });
};

//authenticate shipment
export const authenticatePassword = (model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosWithoutHaeders("Post", APIPaths.authenticate_password, model, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Error while sharing shipment:", error?.response);
        reject(error?.response);
      });
  });
};

//Resolve alerts

export const ResolvedAlert = (token, id) => {
  const url = `${APIPaths.resloved_alert}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

// Get Shipment Alerts detail
export const GetShipmentAlertsPublically = (id) => {
  const url = `${APIPaths.shipment_alert}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosWithoutHaeders("Get", url, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

// Get Shipment Alerts detail
export const GetShipmentAlerts = (token, id) => {
  const url = `${APIPaths.shipment_alert}${id}/`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//Api for bulk upload
export const UploadShipmentFile = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPostForUpload("Post", APIPaths.uploadBulkShipment, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//upload file api
export const uploadFile = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPostForUpload("Post", APIPaths.uploadFile, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

//Api for download Template

export const DownloadBulkShipmentTemplate = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGetDownload("Get", APIPaths.downloadBulkUploadTemplate, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

// archive shipment
export const ArchiveShipment = (id, token) => {
  const url = `${APIPaths.shipment_archive}`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosDelete("Delete", url, id, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

// mark as delivered shipment

export const MarkAsDelivered = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.shipment_mark_as_delivered, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};
export const initiateAiCall = (payload) => {
  const baseDomain = process.env.REACT_APP_WEB_AI;
  return axios
    .post(`${baseDomain}ai/intervention/call/initiate/`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error("AI Call Initiation Error:", error?.response || error);
      throw error?.response || error;
    });
};

export const initiateAiEmail = (payload) => {
  const baseDomain = process.env.REACT_APP_WEB_AI;
  return axios
    .post(`${baseDomain}ai/intervention/email/initiate/`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error("AI Email Initiation Error:", error?.response || error);
      throw error?.response || error;
    });
};
export const initiateAiCallValidate = (payload) => {
  const baseDomain = process.env.REACT_APP_WEB_AI;
  return axios
    .post(`${baseDomain}ai/intervention/call/validate/`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error("AI Call Initiation Error:", error?.response || error);
      throw error?.response || error;
    });
};

export const initiateTestAiCall = (payload) => {
  const baseDomain = process.env.REACT_APP_WEB_AI;
  return axios
    .post(`${baseDomain}ai/notification/call/preview/`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error("AI Call Initiation Error:", error?.response || error);
      throw error?.response || error;
    });
};

export const initiateAiEmailValidate = (payload) => {
  const baseDomain = process.env.REACT_APP_WEB_AI;
  return axios
    .post(`${baseDomain}ai/intervention/email/validate/`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error("AI Email Initiation Error:", error?.response || error);
      throw error?.response || error;
    });
};

export const dontShowMessage = (token, payload) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.noMessage, payload, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error("AI Call Initiation Error:", error?.response);
        reject(error?.response);
      });
  });
};
export const getCallTranscript = (token, alertId) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", `${APIPaths.callTranscript}${alertId}/`, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error("Call Transcript Fetch Error:", error?.response);
        reject(error?.response);
      });
  });
};

export const getEmailTranscript = (token, alertId) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet("Get", `${APIPaths.emailTranscript}${alertId}/`, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error("Email Transcript Fetch Error:", error?.response);
        reject(error?.response);
      });
  });
};
export const shipmentAlertAiStatus = (token, payload) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.shipmentAlertStatus, payload, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error("AI Call Initiation Error:", error?.response);
        reject(error?.response);
      });
  });
};

export const shipmentNotificationListing = (token, shipmentId) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet(
        "Get",
        `${APIPaths.shipmentNotificationListing}?shipment_id=${shipmentId}`,
        token
      )
      .then((res) => resolve(res))
      .catch((error) => {
        console.error("Email Transcript Fetch Error:", error?.response);
        reject(error?.response);
      });
    });
  };
  export const deleteShipmentNotification = (id, token) => {
    const url = `${APIPaths.addShipmentNotification}${id}/`;
    return new Promise((resolve, reject) => {
      interceptor
      .axiosDelete("Delete", url, null, token) // No payload for DELETE
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
    });
  };
  export const updateShipmentNotification = (token, model, notificationId) => {
    return new Promise((resolve, reject) => {
      interceptor
      .axiosPut("Put", `${APIPaths.addShipmentNotification}${notificationId}/`, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
    });
  };
  
  
  export const createShipmentNotification = (token, model) => {
    return new Promise((resolve, reject) => {
    interceptor
    .axiosPost("Post", APIPaths.addShipmentNotification, model, token)
    .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
    });
  };

export const GetShipmentLinkCodes = (token) => {
  return new Promise((resolve, reject) => {
    interceptor
    .axiosGet("Get", APIPaths.get_link_code, token, null)
    .then((res) => {
      resolve(res);
    })
    .catch((error) => {
      console.log("error?.response getting link codes", error?.response);
      reject(error?.response);
    });
  });
};

export const shipmentNotificationRecipient = (token, shipmentId) => {
  return new Promise((resolve, reject) => {
    interceptor
    .axiosGet(
      "Get",
      `${APIPaths.notificationRecipient}?shipment_id=${shipmentId}`,
      token
    )
    .then((res) => resolve(res))
    .catch((error) => {
      console.error("Email Transcript Fetch Error:", error?.response);
      reject(error?.response);
    });
  });
};

export const externalShipmentAlert = (model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.setExternalAlert, model)
      .then((res) => resolve(res))
      .catch((error) => {
        console.error("Set alert Error:", error?.response);
        reject(error?.response);
      });
  });
};
//bulk shipment apis
export const uploadBulkShipment = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPostForUpload("Post", APIPaths.bulkUpload, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const columnMatching = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.bulkValidate, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};

export const bulkCreate = (token, model) => {
  return new Promise((resolve, reject) => {
    interceptor
      .axiosPost("Post", APIPaths.bulkCreate, model, token)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("error?.response?.data?.error", error?.response);
        reject(error?.response);
      });
  });
};


